<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Contrat - {{ cultLabel }}
      </div>
      <div class="right">
        <v-ons-toolbar-button v-if="isContrat" @click="deleteContratConfirm">
          <v-ons-progress-circular v-if="isSubmitDelete" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          <v-ons-icon v-else icon="fa-pencil-alt"></v-ons-icon>
        </v-ons-toolbar-button>
        <v-ons-toolbar-button v-else @click="deleteVenteConfirm">
          <v-ons-progress-circular v-if="isSubmitDelete" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          <v-ons-icon v-else icon="trash"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="content">

      <img :src="negoceImg + '.png'" :srcset="negoceImg + '@2x.png 2x'" class="perfnegoce" />

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list-title v-if="! isContrat" modifier="perflist">
        Détails de la vente
      </v-ons-list-title>
      <v-ons-list modifier="noborder perflist">

        <template v-if="isContrat">

          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">Agriculteur</div>
            <div class="right">{{ clientInfos ? clientInfos.name : 'n.c.' }}</div>
          </v-ons-list-item>

          <v-ons-list-item v-if="clientInfos && clientInfos.societe" modifier="nodivider perfcours">
            <div class="center">Exploitation</div>
            <div class="right">{{ clientInfos.societe }}</div>
          </v-ons-list-item>

        </template>

        <v-ons-list-item modifier="nodivider perfcours">
          <div class="center">Campagne</div>
          <div class="right">{{ campagne }}</div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider perfcours">
          <div class="center">Culture</div>
          <div class="right">{{ cultLabel }}</div>
        </v-ons-list-item>

        <v-ons-list-item v-if="vente.label_prix" modifier="nodivider perfcours">
          <div class="center">Type de contrat</div>
          <div class="right">{{ vente.label_prix }}</div>
        </v-ons-list-item>

        <app-vente-tonne :vente-tonne="vente.tonne" :infos-reste="getContratInfos('reste', true)"></app-vente-tonne>

        <v-ons-list-item v-if="vente.prix !== ''" modifier="nodivider perfcours" :expandable="!!prixItemCours" :expanded.sync="isShow.prixActuel">
          <div class="center">
            {{ prixItem && prixItem.input_label_prix ? prixItem.input_label_prix : 'Prix' }}
          </div>
          <div class="right">
            {{ vente.prix.toLocaleString('fr', { minimumFractionDigits: 2 }) }}&nbsp;€/t
            <span v-if="prixItemCours" class="list-item__expand-chevron"></span>
          </div>
          <div v-if="prixItemCours" class="expandable-content">
            <v-ons-list modifier="noborder nopadding">
              <v-ons-list-item modifier="perfcours">
                <div class="center">
                  Prix actuel
                </div>
                <div class="right">
                  <div class="badge" :class="{ 'badge-vert': prixItemCours.var > 0, 'badge-rouge': prixItemCours.var < 0 }">
                    {{ formatCoursDiff(prixItemCours.var) }}
                  </div>
                  <div style="width: auto"><!-- .badge + div : fixed with -->
                    {{ prixItemCours.val.toLocaleString('fr', { minimumFractionDigits: 2 }) }}&nbsp;€/t
                  </div>
                </div>
              </v-ons-list-item>
            </v-ons-list>
          </div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider perfcours">
          <div class="center">Date du contrat</div>
          <div class="right">{{ vente.date }}</div>
        </v-ons-list-item>

        <app-vente-id :vente-id="displayIdVente(vente.id)" :infos-link="getContratInfos('link', true)">
        </app-vente-id>

        <v-ons-list-item v-if="vente.comment" modifier="nodivider perfcours">
          <div class="center">
            <div>
              Commentaire de l'agriculteur
              <br />
              «
              <i>
                <span v-for='(comment, index) in vente.comment.split("\n")' :key="index"><br v-if="index" />{{ comment }}</span>
              </i>
              »
            </div>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="vente.comment_tc" modifier="nodivider perfcours">
          <div class="center">
            <div>
              Commentaire du technicien
              <br />
              «
              <i>
                <span v-for='(comment, index) in vente.comment_tc.split("\n")' :key="index"><br v-if="index" />{{ comment }}</span>
              </i>
              »
            </div>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="! isContrat" modifier="perfbutton" key="list-item-btn">
          <v-ons-button modifier="quiet" @click="showVenteEdit">
            Modifier les informations
          </v-ons-button>
        </v-ons-list-item>

        <template v-if="isContrat">

          <v-ons-list-item modifier="nodivider perfcours chevron" @click="showContratPdf">
            <div class="center">
              <v-ons-icon icon="file-download"></v-ons-icon>&nbsp;
              Afficher le contrat PDF
            </div>
          </v-ons-list-item>

          <v-ons-list-item modifier="nodivider label" expandable :expanded.sync="isShow.note">
            <div class="center">Ajouter une note personnelle</div>
            <div class="expandable-content">
              <textarea @click="$event.stopPropagation()" class="textarea textarea--transparent" rows="3" placeholder="Écrire ici..."
                        v-model="vente.note"></textarea>
            </div>
          </v-ons-list-item>

          <v-ons-list-item v-if="isShow.note" modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="saveNote">
              Enregistrer la note
            </v-ons-button>
          </v-ons-list-item>

        </template>

      </v-ons-list>

      <template v-if="! isContrat">
        <v-ons-list-title modifier="perflist">
          Informations du vendeur
        </v-ons-list-title>
        <v-ons-list modifier="noborder perflist">
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Exploitation
            </div>
            <div class="right">
              {{ vente.contrat.client.ferme }}
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Adresse
            </div>
            <div class="right">
              {{ vente.contrat.client.ligne4 }}
              <br />
              {{ vente.contrat.client.cp }} {{ vente.contrat.client.ville }}
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Représenté par
            </div>
            <div v-if="vente.contrat.client.name" class="right">
              {{ vente.contrat.client.name }}
            </div>
            <div v-else class="right">
              {{ vente.contrat.client.nom.toUpperCase() }} {{ vente.contrat.client.prenom }}
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Email
            </div>
            <div class="right">
              {{ vente.contrat.client.email }}
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Téléphone
            </div>
            <div class="right">
              {{ vente.contrat.client.tel }}
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Code tiers
            </div>
            <div class="right">
              {{ vente.contrat.client.erp }}
            </div>
          </v-ons-list-item>
          <template v-if="vente.contrat.client.silo !== undefined || negoceInfos.silo">
            <v-ons-list-item modifier="nodivider perfcours">
              <div class="center">
                Code silo
              </div>
              <div class="right">
                {{ vente.contrat.client.silo }}
              </div>
            </v-ons-list-item>
          </template>
          <v-ons-list-item modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="showContratEdit">
              Modifier les informations
            </v-ons-button>
          </v-ons-list-item>
        </v-ons-list>

        <v-ons-list-title modifier="perflist">
          Détails du prix
        </v-ons-list-title>
        <v-ons-list modifier="noborder perflist">
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Livraison
            </div>
            <div class="right">
              <template v-for="(item, index) in vente.contrat.detail.livraison">
                {{ item }}
                <br :key="'content-' + index">
              </template>
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Qualité
            </div>
            <div class="right">
              <template v-for="(item, index) in vente.contrat.detail.qualite">
                {{ item }}
                <br :key="'content-' + index">
              </template>
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">
              Paiement
            </div>
            <div class="right">
              <template v-for="(item, index) in vente.contrat.detail.paiement">
                {{ item }}
                <br :key="'content-' + index">
              </template>
            </div>
          </v-ons-list-item>
          <v-ons-list-item v-if="vente.contrat.detail.observation && vente.contrat.detail.observation.length" modifier="nodivider perfcours">
            <div class="center">
              Observations
            </div>
            <div class="right">
              <template v-for="(item, index) in vente.contrat.detail.observation">
                {{ item }}
                <br :key="'content-' + index">
              </template>
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="showContratEdit">
              Modifier les informations
            </v-ons-button>
          </v-ons-list-item>
        </v-ons-list>
      </template>

      <footer class="footer--perfbutton">
        <v-ons-button v-if="! isContrat" modifier="large--cta perflarge" @click="saveContrat">
          Générer le contrat
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
        <v-ons-button v-else-if="isOTP" modifier="large--cta perflarge" @click="isShow.otp = true">
          Signer le contrat
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
        <a v-if="clientInfos" href="#" @click="callClient(vente.client, clientInfos, 'contrat visu')">
          <v-ons-icon icon="fa-phone"></v-ons-icon>
          Appeler l'agriculteur
        </a>
      </footer>
      
    </div>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="isShow.otp">
      <template slot="title">
        Code SMS
      </template>
      Veuillez renseigner le code reçu par {{ clientContact }} pour valider la signature :
      <v-ons-list modifier="noborder nopadding transparent">
        <app-input input-id="inputOtp" ref="inputOtp" v-model="otp.value" placeholder="Indiquez le code à 6 chiffres" @keyup-enter="closeKeyboard">
        </app-input>
      </v-ons-list>
      <template slot="footer">
        <v-ons-alert-dialog-button @click="isShow.otp = false">Annuler</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button modifier="primal" @click="saveOTP">Valider</v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppInput from '../partials/Input.vue';
import AppVenteTonne from '../partials/VenteTonne.vue';
import AppVenteId from '../partials/VenteId.vue';

import AppContratEdit from './ContratEdit.vue';
import AppContratPdf from './ContratPdf.vue';
import AppVenteDemande from './VenteDemande.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppErrorMsg, AppInput, AppVenteTonne, AppVenteId },
  props: ['pageStack'],
  data() {
    return {
      negoceId: '',
      indexVente: -1,
      refCulture: '',
      refDestination: '',
      vente: {
        id: '',
        etat: '',
        client: '',
        id_prix: '',
        label_prix: '',
        tonne: '',
        prix: '',
        date: '',
        comment: '',
        comment_tc: '',
        contrat: {},
        note: '',
      },
      isOTP: false,
      isShow: {
        prixActuel: false,
        note: false,
        otp: false
      },
      otp: {
        value: '',
      },
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel(){
      return this.getCultLabel();
    },
    clientInfos() {
      return this.getClientInfosTech(this.data.negoce.clients, this.vente.client);
    },
    clientContact() {
      return this.getClientContact(this.clientInfos);
    },
    negoceInfos() {
      return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
    },
    prixItem() {
      var listPrix = this.getListPrix(this.negoceInfos, this.refCulture, this.refDestination);
      for (let i = 0; i < listPrix.length; i++) {
        var prixItem = listPrix[i];
        if(prixItem.id == this.vente.id_prix){
          return prixItem;
        }
      }
    },
    prixItemCours() {
      if(! this.isContrat && this.prixItem && this.prixItem.cours !== ''){
        return {
          val: this.prixItem.cours,
          var: this.prixItem.cours - this.vente.prix,
        }
      }
    },
    isContrat() {
      return this.vente.etat == 'contrat';
    }
  },
  methods: {
    async saveContrat() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        index_vente: this.indexVente,
        id_vente: this.vente.id
      };

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/negoce/contrat');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        this.pageStack.length > 1 && this.pageStack.pop();
        this.$showToast('Contrat transmis par email');
      } catch(error) {
        this.handleError(error);
      }
    },
    async saveOTP() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      this.isSubmit = true;

      if(! this.otp.value){
        this.setErrorMsgList('inputOtp', '');
        this.isSubmit = false;
        return;
      }
      this.isShow.otp = false;

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        index_vente: this.indexVente,
        id_vente: this.vente.id,
        otp: this.otp.value,
        is_tech: true
      };

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/negoce/signe');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        this.pageStack.length > 1 && this.pageStack.pop();
        this.$showToast('Contrat signé électroniquement');
      } catch(error) {
        if(error && error.status == 409){
          this.isOTP = false;
        }
        this.handleError(error);
      }
    },
    showContratEdit() {
      var negoceId = this.negoceId;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      var indexVente = this.indexVente;
      this.pageStack.push({
        extends: AppContratEdit,
        data() {
          return {
            negoceId: negoceId,
            indexVente: indexVente,
            refCulture: refCulture,
            refDestination: refDestination
          }
        }
      });
    },
    showVenteEdit() {
      var negoceId = this.negoceId;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      var indexVente = this.indexVente;
      this.pageStack.push({
        extends: AppVenteDemande,
        data() {
          return {
            negoceId: negoceId,
            refCulture: refCulture,
            refDestination: refDestination,
            indexVente: indexVente
          }
        }
      });
    },
    saveNote() {
      var body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        index_vente: this.indexVente,
        data: this.vente.note
      };

      store.state.user.ventes[this.refCulture][this.refDestination].done[this.indexVente].note = this.vente.note;
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          path: this.getPath('/vente/note'),
          data: body
        }
      });

      this.pageStack.pop();
    },
    deleteContratConfirm() {
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Attention !',
        message: "Êtes-vous sûr de vouloir modifier ce contrat ?",
        buttonLabels: ['Annuler', 'Modifier'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteContrat();
          }
        }.bind(this)
      });
    },
    async deleteContrat() {
      this.isSubmitDelete = true;

      const call = {
        method: 'DELETE',
        path: this.getPath('/negoce/contrat'),
        data: {
          id: this.user.id,
          date: this.user.date,
          ref_culture: this.refCulture,
          ref_destination: this.refDestination,
          index_vente: this.indexVente,
          id_vente: this.vente.id
        }
      };

      const fetchInit = this.$getFetchInit(call.method);
      fetchInit.body = JSON.stringify(call.data);
      const callPath = this.$apiDomain + call.path;
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        this.setVente(this.strategie.done[this.indexVente]);

        var negoceId = this.negoceId;
        var refCulture = this.refCulture;
        var refDestination = this.refDestination;
        var indexVente = this.indexVente;
        this.pageStack.push({
          extends: AppContratEdit,
          data() {
            return {
              negoceId: negoceId,
              indexVente: indexVente,
              refCulture: refCulture,
              refDestination: refDestination
            }
          }
        });
        this.isSubmitDelete = false;
      } catch(error) {
          this.handleError(error, 'de la modification du contrat');
      }
    },
    deleteVenteConfirm() {
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Attention !',
        message: "Êtes-vous sûr de vouloir supprimer cette vente ?",
        buttonLabels: ['Annuler', 'Supprimer'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteVente();
          }
        }.bind(this)
      });
    },
    async deleteVente() {
      this.isSubmitDelete = true;

      var call = {
        method: 'DELETE',
        path: this.getPath('/negoce/vente'),
        data: {
          id: this.user.id,
          date: this.user.date,
          ref_culture: this.refCulture,
          ref_destination: this.refDestination,
          index_vente: this.indexVente,
          id_vente: this.vente.id
        }
      };

      var fetchInit = this.$getFetchInit(call.method);
      fetchInit.body = JSON.stringify(call.data);
      const callPath = this.$apiDomain + call.path;
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        this.pageStack.length > 1 && this.pageStack.pop();
      } catch(error) {
          this.handleError(error, 'de la suppression de la vente');
      }
    },
    showContratPdf() {
      var indexVente = this.indexVente;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      this.pageStack.push({
        extends: AppContratPdf,
        data() {
          return {
            indexVente: indexVente,
            refCulture: refCulture,
            refDestination: refDestination
          }
        }
      });
    }
  },
  created() {
    this.setVente(this.strategie.done[this.indexVente]);
  },
  mounted() {
    if(this.prixItemCours){
      this.isShow.prixActuel = true;
    }
    if(this.vente.note) {
      this.isShow.note = true;
    }
  }
}
</script>